import './Markers.css';

export function TachoAvailableSvgData(width: number, height: number, fillColor: string) {
  return `
     <svg class="idata-target-marker" width="${width}" height="${height}" viewBox="-2 -2 28 28" fill="${fillColor}" xmlns="http://www.w3.org/2000/svg">
      <path fill-rule="evenodd" clip-rule="evenodd" d="M22 23H2V3H22V23ZM7.31768 19.0976H18.0976V8.31768L7.31768 19.0976ZM5.90244 17.6672L16.6672 6.90244H5.90244V17.6672Z"/>
     </svg>`;
}
